<template>
  <div class="card">
    <div class="card-header border-bottom">
      <ul class="nav nav-tabs card-header-tabs">
        <li
          v-for="tab in batchTabs"
          :key="tab.key"
          class="nav-item"
        >
          <button
            class="nav-link"
            :class="{ active: activeTab === tab.key }"
            @click="selectTab(tab.key)"
          >
            {{ tab.label }}
          </button>
        </li>
      </ul>
    </div>

    <div class="card-body">
      <Suspense>
        <component :is="activeComponent" />
        <template #fallback>
          <div class="text-muted">Loading module…</div>
        </template>
      </Suspense>
    </div>
  </div>
</template>

<script>
import { batchTabs } from '@/utils/batchTabs'

export default {
  data() {
    return {
      activeTab: batchTabs[0].key
    }
  },

  computed: {
    batchTabs() {
      return batchTabs
    },
    activeComponent() {
      const tab = batchTabs.find(t => t.key === this.activeTab)
      return tab?.component
    }
  },

  methods: {
    selectTab(key) {
      this.activeTab = key
    }
  }
}
</script>
